import React from "react";
import { useTheme } from "@mui/material";
import { BadgeBoxProps } from "./types";
import { StyledBadgeBox } from "./style";

const BADGE_TEXT_COLOR = "#000000";

const variantStyles = (theme: any) => ({
  default: {
    background: theme.palette.badge.default.background,
    border: `1px solid ${theme.palette.badge.default.border}`,
    color: BADGE_TEXT_COLOR,
  },
  warning: {
    background: theme.palette.badge.warning.background,
    border: `1px solid ${theme.palette.badge.warning.border}`,
    color: BADGE_TEXT_COLOR,
  },
  success: {
    background: theme.palette.badge.success.background,
    border: `1px solid ${theme.palette.badge.success.border}`,
    color: BADGE_TEXT_COLOR,
  },
  info: {
    background: theme.palette.badge.info.background,
    border: `1px solid ${theme.palette.badge.info.border}`,
    color: BADGE_TEXT_COLOR,
  },
  error: {
    background: theme.palette.badge.error.background,
    border: `1px solid ${theme.palette.badge.error.border}`,
    color: BADGE_TEXT_COLOR,
  },
});

const BadgeBoxCst: React.FC<BadgeBoxProps> = ({
  children,
  background,
  border,
  textColor,
  variant = "default",
  icon,
  sx,
}) => {
  const theme = useTheme();
  const variantStyle = variantStyles(theme)[variant];

  return (
    <StyledBadgeBox
      sx={{
        backgroundColor: background || variantStyle.background,
        border: border || variantStyle.border,
        color: textColor || variantStyle.color,
        fontWeight: 600,
        fontSize: "0.75rem",
        "& svg": {
          width: "14px",
          height: "14px",
        },
        ...sx,
      }}
    >
      {icon}
      {children}
    </StyledBadgeBox>
  );
};

export default BadgeBoxCst;
